module.exports = __webpack_public_path__ + "img/IMG_2493_L_Black_MockedUp.ae833ec0.jpg";